module.exports = {
	SHARED_FOLDER_USER_TYPES: {
		SHARED_FOLDER_CREATOR: 1,
		SHARED_FOLDER_VIEWER: 2,
	},
};
